
import { Checkbox, KoButton, KoColorPicker, KoDate, KoForm, KoFormBuilder, KoLoader, KoModal, KoNano, KoNumber, KoSelect, KoText, KoToast, KoUserSelect, KoWorkflow } from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import styles from './workspace.module.scss';
import { workspaceAPI } from './workspace.service';
import { useSelector } from 'react-redux';
import AssignesUpdate from './assigneesUpdate';
import ActivityEditor from 'packages/workflow/activityType';
import Forms from './forms';
import SyncTask from './sync';

export default function WorkspaceSettings({ form, handleFinish, templateData,
  assigneeForm, initialValues, getWorkspace, resetWorkflow, setTemplateModal, updateWorkflowRows }) {
  const users = useSelector(state => state?.users);
  const [cusForm] = KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [currentRecord, setCurrentRecord] = useState(initialValues);
  const [active, setActiveStep] = useState('basic');
  const [isCustomerModalOpen, setCustomerModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempFormData, setTempFormData] = useState();
  useEffect(() => {
    if (initialValues) {
      setCurrentRecord(initialValues);
      setTempFormData(initialValues);
    }
  }, [initialValues]);

  useEffect(() => {
    getClients();
  }, []);


  const generateKey = (name) => {
    const nameWords = name.trim().split(' ');

    if (nameWords.length === 1) {
      return nameWords[0].slice(0, 3).toUpperCase();
    } else {
      return nameWords.map(word => word.charAt(0)).join('').toUpperCase();
    }
  };

  const handleSubmit = (val) => {
    let values = val?.name ? val : tempFormData;
    values['key'] = !initialValues ? generateKey(values.name) : initialValues['key'];
    let data = {
      ...currentRecord,
      ...values
    };
    handleFinish(data);
  };

  const getClients = () => {
    setLoading(true);
    workspaceAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const Assignees = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={users['data']} placeholder='Select assignees' />;

  const TypeofBilling = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      placeholder='Select Billing Type'
      options={[{
        label: 'Billable',
        value: 'billable'
      }, {
        label: 'Non-Billable',
        value: 'nonBillable'
      }]?.map((bill) => ({
        label: bill?.label,
        value: bill?.value
      }))}
    />;

  const SprintDate = ({ value, onChange }) => {
    const holidays = useSelector(state => state?.holidays);
    return (
      <KoDate
        holidays={holidays?.data}
        userLeave={false}
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const usedColors = new Set();

  const getRandomLightColor = () => {
    const randomChannelValue = () => Math.floor(Math.random() * 128) + 128;

    let color;


    do {
      const r = randomChannelValue();
      const g = randomChannelValue();
      const b = randomChannelValue();


      const toHex = (c) => {
        const hex = c.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      color = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    } while (usedColors.has(color));

    usedColors.add(color);

    return color;
  };

  const WosColor = ({ value, onChange }) => {

    const handleChange = (colorValue) => {
      const { r, g, b } = colorValue.metaColor;
      const hexColor = rgbToHex(r, g, b);
      onChange(hexColor);
    };
    return (
      <KoColorPicker value={value} defaultValue={currentRecord?.color || getRandomLightColor()} onChange={handleChange} />
    );
  };

  const rgbToHex = (r, g, b) => {
    const toHex = (c) => {
      const hex = Math.round(c).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };



  const STATUS = [{
    label: 'Planning',
    key: 'planning',
    value: 0
  }, {
    label: 'Active',
    key: 'active',
    value: 1
  },
  {
    label: 'Inactive',
    key: 'inactive',
    value: 4
  },
  {
    label: 'Paused',
    key: 'paused',
    value: 3
  }];

  const Status = ({ value, onChange }) => {
    const getStatusOptions = () => {
      return STATUS.map(status => ({
        ...status,
        disabled: value === 1 && status.value === 0 // If Active, disable Planning
      }));
    };

    return (
      <KoSelect
        value={value}
        showSearch
        onChange={v => onChange(v)}
        placeholder='Select status'
        options={getStatusOptions()}
        optionRender={(option) => {
          const label = option?.data?.label;
          const disabled = option?.data?.disabled;
          return (
            <div className={`${styles.statusWrapper} ${disabled ? styles.disabled : ''}`}>
              <div className={`${styles.status} ${styles[label]}`} />
              <KoText text={option.label} />
            </div>
          );
        }}
      />
    );
  };


  const Customer = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Help desk`}</Checkbox>;

  const CheckBoxSprint = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Enable Sprint`}</Checkbox>;

  // const TextArea = ({ value, onChange }) =>
  //   <KoTextArea
  //     maxLength={100}
  //     rows={3}
  //     placeholder="Enter description"
  //     showCount
  //     value={descriptionData}
  //     onChange={(e) => setDescriptionData(e.target.value)}
  //   />;



  const formMeta = {
    columns: 6,
    formItemLayout: null,
    initialValues: currentRecord,
    colon: true,
    fields: [
      {
        key: 'name', label: 'Name', colSpan: 4,
        placeholder: 'Enter project name',
        rules: [
          {
            required: true,
            message: `Enter new project name.`
          }
        ]
      },
      {
        key: 'customer', label: <div className={styles.assigneeLabel}>
          <KoText text={'Customer'} />
          <KoText className={styles.assignToMe} text={'(Or Add New)'} onClick={() => setCustomerModal(true)} />
        </div>, colSpan: 2,
        widget: Customer,
        rules: [
          {
            required: true,
            message: `Select a customer.`
          }
        ]
      },

      {
        key: 'status', label: 'Status', colSpan: 2,
        widget: Status
      },

      {
        key: 'idealStartDate', placeholder: 'Enter Ideal Start Date', label: 'Ideal Start Date', colSpan: 2, widget: SprintDate
      },
      {
        key: 'idealEndDate', placeholder: 'Enter Ideal End Date', label: 'Ideal End Date', colSpan: 2, widget: SprintDate
      },
      {
        key: 'description', maxLength: 100, widget: 'textarea', label: 'Description', colSpan: 6, placeholder: 'Enter project description'
      },
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>ADVANCED SETTINGS</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'color', label: 'Workspace Color', colSpan: 2, widget: WosColor
      },
      {
        key: 'isPublic',
        colSpan: 2,
        label: 'Make public',
        widget: CheckBox
      },
      {
        key: 'enableSprint',
        colSpan: 2,
        label: 'Enable Sprint Planning',
        widget: CheckBoxSprint
      },
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend></legend>
            </fieldset>
          );
        }
      },
      {
        key: 'defaultAssignee', label: 'Default issue Assignee', colSpan: 2, widget: Assignees
      },
      {
        key: 'typeofBilling', label: 'Type of Billing', colSpan: 2, widget: TypeofBilling
      },
      {
        key: 'storyPoints', label: 'Story Points',
        colSpan: 2, widget: KoNumber
      },
      {
        key: 'maxHours', label: 'Maximum Hours per Day',
        colSpan: 2, widget: KoNumber
      },
      {
        key: 'allocatedBudget', placeholder: 'Ex: 1000000', label: 'Allocated Budget', colSpan: 2, widget: KoNumber
      }

    ]
  };

  const handelChangeStep = (value) => {
    setActiveStep(value);
  };

  const handleSubmitCustomer = (values) => {
    setLoading(true);
    values['customerId'] = KoNano('CUS');
    workspaceAPI.createOrUpdateCompany(values, "CLI3103B7FE26").then(
      (data) => {
        getClients();
        form.setFieldsValue({ customer: values.customerId });
        KoToast.success('Customer created successfully');
        setCustomerModal(false);
        cusForm.resetFields();
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      {
        key: 'companyName', label: 'Customer / Company Name', colSpan: 4,
        placeholder: 'Enter customer / company name',
        rules: [
          {
            required: true,
            message: `Enter customer / company name.`
          }
        ]
      }
    ]
  };

  return (
    <div className={styles.wizardMeta}>
      <div className={styles.sideNavigation}>
        <ul>
          <li onClick={() => handelChangeStep('basic')} className={`${active === 'basic' && styles.active}`}>
            <KoIcon name="ProjectsOutlined" color={active === 'basic' ? `#007867` : ``} width={18} height={18} />
            <KoText text={`Basic Details`} />
          </li>
          {initialValues?.workspaceId && <li onClick={() => handelChangeStep('teams')} className={`${active === 'teams' && styles.active}`}>
            <KoIcon name="UsersOutlined" color={active === 'teams' ? `#007867` : ``} width={14} height={14} />
            <KoText text={`Teams`} />
          </li>}
          <li onClick={() => handelChangeStep('workflow')} className={`${active === 'workflow' && styles.active}`}>
            <KoIcon name="WorkflowOutlined" color={active === 'workflow' ? `#007867` : ``} width={18} height={18} />
            <KoText text={`Workflow`} />
          </li>

          <li onClick={() => handelChangeStep('activity')} className={`${active === 'activity' && styles.active}`}>
            <KoIcon name="TimeLineOutlined" color={active === 'activity' ? `#007867` : ``} width={18} height={18} />
            <KoText text={`Activity Types`} />
          </li>
          <li onClick={() => handelChangeStep('forms')} className={`${active === 'forms' && styles.active}`}>
            <KoIcon name="FileOutlined" color={active === 'forms' ? `#007867` : ``} width={18} height={18} />
            <KoText text={`Forms`} />
          </li>
          <li onClick={() => handelChangeStep('settings')} className={`${active === 'settings' && styles.active}`}>
            <KoIcon name="SettingsOutlined" color={active === 'activity' ? `#007867` : ``} width={18} height={18} />
            <KoText text={`Settings`} />
          </li>
        </ul>
      </div>
      <div className={`${styles.formWrapper} ${active === 'basic' ? styles.customForm : ''}`}>
        <KoForm form={form} layout="vertical" onFinish={handleSubmit} onValuesChange={(_, allValues) => {
          setTempFormData(allValues);
        }}>
          {active === 'basic' &&
            <KoFormBuilder form={form} meta={formMeta} />
          }
          {active === 'teams' && <AssignesUpdate
            assigneeForm={assigneeForm}
            workspaceName={currentRecord?.name}
            getWorkspace={getWorkspace}
            createdBy={currentRecord?.createdBy}
            workspaceId={currentRecord?.workspaceId} />}

          {active === 'workflow' &&
            <div className={`${styles.workflowTree} tableCard`}>
              <KoWorkflow resetWorkflow={resetWorkflow} workspace={currentRecord} setTemplateModal={setTemplateModal} data={templateData} onChange={updateWorkflowRows} height={'calc(100vh - 45rem)'} />
            </div>
          }
          {
            active === 'activity' &&
            <div className={`${styles.workflowTree} tableCard`}>
              <ActivityEditor workspace={currentRecord} setTemplateModal={setTemplateModal} data={templateData} onChange={updateWorkflowRows} height={'calc(100vh - 45rem)'} />
            </div>
          }
          {active === 'forms' && <Forms />}
          {
            active === 'settings' &&
            <div className={`${styles.workflowTree} tableCard`}>
              <SyncTask workspace={currentRecord} />
            </div>
          }

        </KoForm>
      </div>
      <KoModal
        title={`Create new Customer`}
        open={isCustomerModalOpen}
        width={'40%'}
        centered
        onClose={() => setCustomerModal(false)}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCustomerModal(false)} />,
          <KoButton key='create' type='primary' label={`Create`}
            onClick={() => cusForm.submit()} />
        ]}
      >
        <div className={styles.customerName}>
          {loading && <KoLoader />}
          <KoForm form={cusForm} layout="vertical" onFinish={handleSubmitCustomer}>
            <KoFormBuilder form={cusForm} meta={meta} />
          </KoForm>
        </div>
      </KoModal>
    </div>
  );
}
